import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Spaces from "../pages/spaces/page";
import NewSpace from "../pages/spaces/new/page";
import Boxes from "../pages/boxes/page";
import NewBox from "../pages/boxes/new/page";
import Profile from "../pages/profile/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/spaces",
    element: <Spaces />,
  },
  {
    path: "/spaces/new",
    element: <NewSpace />,
  },
  {
    path: "/boxes",
    element: <Boxes />,
  },
  {
    path: "/boxes/new",
    element: <NewBox />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
